import React from 'react';
import { Box } from '@mui/material';
import { InterventionLadderStepModel } from '../../../api-service/clients';
import { formatNumber } from '../../../utilities';
import { InternalExternalSplit } from './intervention-cost';

export function formatSuppliers(count: number) {
  return count === 1 ? 'leverandør' : 'leverandører';
}

export function formatActivitiesWithUnknownSupplier(count: number) {
  return `${formatNumber(count)} ${count === 1 ? 'aktivitet' : 'aktiviteter'} uden kendt leverandør`;
}

export function InterventionLadderStepSuppliers({ step }: { step: InterventionLadderStepModel }) {
  const { suppliers } = step;
  return (
    <Box
      role="group"
      aria-label={`Leverandører på trin ${step.step}: ${formatNumber(suppliers.total)}`}
      sx={{ borderRadius: '10px', px: 1.75, py: 1.5, bgcolor: '#f3f8fb', border: '1px solid rgba(24, 76, 97, 0.12)', color: '#16323d' }}
    >
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
        <Box sx={{ fontSize: '1.25rem', fontWeight: 500, fontVariantNumeric: 'tabular-nums' }}>{formatNumber(suppliers.total)}</Box>
        <Box sx={{ fontSize: '0.6875rem', color: 'text.secondary' }}>{formatSuppliers(suppliers.total)}</Box>
      </Box>
      <InternalExternalSplit
        internal={suppliers.internal}
        external={suppliers.external}
        format={formatNumber}
        label={`${formatNumber(suppliers.internal)} interne, ${formatNumber(suppliers.external)} eksterne`}
      />
      {suppliers.activitiesWithUnknownSupplier > 0 && (
        <Box sx={{ fontSize: '0.6875rem', mt: 0.25, color: 'text.secondary' }}>{formatActivitiesWithUnknownSupplier(suppliers.activitiesWithUnknownSupplier)}</Box>
      )}
    </Box>
  );
}
